<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  ratio: {
    type: Number,
    default: 1 / 1,
    required: true
  }
})

const MAX_RATIO = 2
const MIN_RATIO = 0.5

const innerRatio = computed(() => {
  let r = props.ratio
  if (r > MAX_RATIO) {
    r = MAX_RATIO
  } else if (r < MIN_RATIO) {
    r = MIN_RATIO
  }
  return r * 100
})
</script>
<template>
  <div class="block">
    <div class="inner" :style="{ 'padding-bottom': innerRatio + '%' }">
      <div class="container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.block {
  width: 100%;
  height: 100%;
  margin: 0 auto;

  .inner {
    width: 100%;
    height: 0;

    .container {
      position: absolute;
      inset: 0;
    }
  }
}
</style>
